// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","imageFollow":"Card_imageFollow__Uj7wc","follow":"Card_follow__RXiiv","textSize":"Card_textSize__fj2QZ"};